<template>
  <div class="inline-block text-white rounded-md" :class="badgeClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
const { severity = "primary", size = "md" } = defineProps<{
  severity?:
    | "primary"
    | "blue"
    | "success"
    | "info"
    | "indigo"
    | "warning"
    | "error"
    | "yellow";
  size?: "lg" | "md" | "sm";
}>();

const badgeClass = computed(() => ({
  //color
  "bg-primary-500": severity === "primary",
  "bg-blue-500": severity === "blue",
  "bg-cyan-600": severity === "info",
  "bg-green-600": severity === "success",
  "bg-indigo-600": severity === "indigo",
  "bg-orange-600": severity === "warning",
  "bg-[#EF4444]": severity === "error",
  "bg-yellow-600": severity === "yellow",

  //size
  "px-4 py-2": size === "lg",
  "px-2.5 py-1 text-sm font-medium": size === "md",
  "px-1.5 py-1 text-[10px] font-semibold": size === "sm",
}));
</script>
